import OfflinePaymentButton from 'hb-react/shared/apps/Memberships/components/OfflinePaymentButton';
import getPageCustomizableHeaderControls from 'hb-react/shared/apps/PageCustomizables/utils/getPageCustomizableHeaderControls';
import MoreInfoButton from 'hb-react/shared/components/MoreInfoButton';

const useMembershipsHeaderControls = ({ appPageConfig, programme = {} }) => {
  const { secondaryButton } = getPageCustomizableHeaderControls({
    appPageConfig,
  });
  const {
    online_payment: onlinePayment,
    instruction_type: instructionType,
    description_active: descriptionActive,
    description,
    offline_payment_document: offlinePaymentDocument,
    external_link: externalLink,
  } = programme || {};

  const controls = [];

  if (descriptionActive && description) {
    controls.push(<MoreInfoButton htmlBlock={description} />);
  }

  const href =
    instructionType === 'document' && offlinePaymentDocument
      ? offlinePaymentDocument
      : externalLink;
  const label =
    instructionType === 'document' && offlinePaymentDocument
      ? __('Payment document')
      : __('Payment instructions');

  const hasOfflinePaymentButton = onlinePayment === false && href;

  if (hasOfflinePaymentButton) {
    controls.push(<OfflinePaymentButton href={href} label={label} />);
  } else if (secondaryButton) {
    controls.push(secondaryButton);
  }

  return {
    controls,
    hasOfflinePaymentButton,
  };
};

export default useMembershipsHeaderControls;
